import axios from 'axios'

import config from '../../config'

const updateSafetyItemUniqueValue = (params = {}, data) => {
  const { airportId } = params

  const url = `${config.baseUrl}/${airportId}/SafetyItemUniqueValues`
  return axios.put(url, data)
}

export default updateSafetyItemUniqueValue
